var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkillsIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "128px",
    height: "128px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fz1Mig8QVDH~5M2SheJyAa",
    x1: 32,
    x2: 32,
    y1: 26.333,
    y2: 43.334,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ab4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e492ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Fz1Mig8QVDH~5M2SheJyAa)",
    d: "M38.124,36.998H36c-0.552,0-1,0.434-1,0.987v3.014c0,0.551-0.446,0.999-0.997,0.999h-4.006 c-0.551,0-0.997-0.448-0.997-0.999v-3.014c0-0.553-0.448-0.987-1-0.987h-2.124c-0.721,0-1.132-0.89-0.7-1.508l5.424-7.76 c0.68-0.973,2.119-0.974,2.799-0.002l5.424,7.763C39.256,36.109,38.844,36.998,38.124,36.998z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fz1Mig8QVDH~5M2SheJyAb",
    x1: 23,
    x2: 23,
    y1: 12.833,
    y2: 53.943,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Fz1Mig8QVDH~5M2SheJyAb)",
    d: "M19,25h2c0-3,2.691-5.999,6-5.999v-2C22.589,17.001,19,21,19,25z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fz1Mig8QVDH~5M2SheJyAc",
    x1: 48.5,
    x2: 48.5,
    y1: 12.833,
    y2: 53.943,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Fz1Mig8QVDH~5M2SheJyAc)",
    d: "M52,30c0-4-3.141-6.999-7-6.999v2c2.757,0,5,1.999,5,4.999H52z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fz1Mig8QVDH~5M2SheJyAd",
    x1: 32,
    x2: 32,
    y1: 12,
    y2: 55.334,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1A6DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C822FF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Fz1Mig8QVDH~5M2SheJyAd)",
    d: "M55.106,34.334C55.699,32.964,56,31.509,56,30.001c0-6.065-4.935-11-11-11 c-2.424,0-4.721,0.777-6.618,2.218c-1.601-4.85-6.147-8.218-11.382-8.218c-6.617,0-12,5.383-12,12C15,26.544,15.062,28,15.53,29H15 c-4.963,0-9,4.037-9,9c0,4.303,3.037,7.906,7.08,8.789C13.461,49.17,15.513,51,18,51h21h6h2c2.437,0,4.466-1.754,4.906-4.065 C55.338,46.488,58,43.553,58,40.001C58,37.734,56.912,35.64,55.106,34.334z M47,49h-2h-6H18c-1.302,0-2.402-1-2.816-2h34.632 C49.402,48,48.302,49,47,49z M51,45H15c-3.859,0-7-3.141-7-7s3.141-7,7-7h3.54l-0.627-1.407C17.083,27.727,17,26.807,17,25.001 c0-5.514,4.486-10,10-10c4.844,0,8.979,3.46,9.833,8.228l0.345,1.924l1.358-1.404c1.714-1.772,4.01-2.748,6.464-2.748 c4.963,0,9,4.037,9,9c0,1.368-0.303,2.683-0.884,3.877l-0.656,1.238l0.882,0.469C54.981,36.456,56,38.148,56,40.001 C56,42.758,53.757,45,51,45z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsIcon2);
export default __webpack_public_path__ + "static/media/skillsIcon2.0d5cb9094c6723e1da55bbcd73e9e815.svg";
export { ForwardRef as ReactComponent };